import './EmailPreview.scss';
import { prefixClass } from 'lib/utils';

import DOMPurify from 'dompurify';
import { FC, useState } from 'react';
import { EmailPreviewExtra } from '../../../../analyzeMessageContent';
import classNames from 'classnames';
import { IconChevronDown } from 'components/Icons';

export interface EmailPreviewProps {
  extra: EmailPreviewExtra;
}
const sanitizeEmail = (html: string) => DOMPurify.sanitize(html, { KEEP_CONTENT: true });

const EmailPreview: FC<EmailPreviewProps> = ({ extra }) => {
  const prefix = prefixClass('q2-message-preview-module-email');
  const sanitized = sanitizeEmail(extra.html);
  const { emailHeaders, isFirstMessage, isAutoDetected } = extra;
  const hasHeaders = emailHeaders.from || emailHeaders.to || emailHeaders.subject;
  const [isHeaderExpanded, setIsHeaderExpanded] = useState(false);

  const toggleHeader = () => setIsHeaderExpanded(prev => !prev);

  return (
    <div className={classNames(prefix(), { 'is-first-message': isFirstMessage })}>
      {/* Show headers for first message or if we have header data (not for auto-detected) */}
      {!isAutoDetected && (isFirstMessage || hasHeaders) && (
        <div className={classNames(prefix('header'), { 'is-expanded': isHeaderExpanded })}>
          {/* Collapsed view - always show From with toggle */}
          <div className={prefix('header-collapsed')} onClick={toggleHeader}>
            <div className={prefix('header-field')}>
              <div className={prefix('header-field-title')}>From:</div>
              <div className={prefix('header-field-content')}>{emailHeaders.from || 'Unknown'}</div>
            </div>
            <span className={classNames(prefix('header-chevron'), { 'is-expanded': isHeaderExpanded })}>
              <IconChevronDown />
            </span>
          </div>

          {/* Expanded view - show To and Subject */}
          {isHeaderExpanded && (
            <div className={prefix('header-expanded')}>
              {emailHeaders.to && (
                <div className={prefix('header-field')}>
                  <div className={prefix('header-field-title')}>To:</div>
                  <div className={prefix('header-field-content')}>{emailHeaders.to}</div>
                </div>
              )}
              {emailHeaders.subject && (
                <div className={prefix('header-field')}>
                  <div className={prefix('header-field-title')}>Subject:</div>
                  <div className={prefix('header-field-content')}>{emailHeaders.subject}</div>
                </div>
              )}
            </div>
          )}
        </div>
      )}
      <div
        className={classNames(prefix('body'), { 'autodetect-email': isAutoDetected })}
        dangerouslySetInnerHTML={{ __html: sanitized }}
      />
    </div>
  );
};

export default EmailPreview;
